import { render, staticRenderFns } from "./MediaManager.ts.vue?vue&type=template&id=2b74483e"
import script from "./MediaManager.ts.vue?vue&type=script&lang=ts"
export * from "./MediaManager.ts.vue?vue&type=script&lang=ts"
import style0 from "./MediaManager.ts.vue?vue&type=style&index=0&id=2b74483e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports